import { createFileRoute } from "@tanstack/react-router";
import { LegalPage } from "@/lib/legal-content";

export const Route = createFileRoute("/gdpr")({
  component: GDPRPage,
  head: () => ({
    meta: [
      { title: "GDPR Compliance — CoderLity" },
      { name: "description", content: "How CoderLity complies with GDPR — data subject rights, lawful basis, DPAs and international transfers." },
      { property: "og:url", content: "/gdpr" },
    ],
    links: [{ rel: "canonical", href: "https://coderlity.com/gdpr" }],
  }),
});

function GDPRPage() {
  return (
    <LegalPage
      eyebrow="Legal"
      title="GDPR Compliance"
      sub="How we handle personal data of EU/UK residents."
      updated="May 1, 2026"
      sections={[
        { heading: "Who we are", body: "CoderLity acts as data controller for our website and marketing, and as data processor for customer data stored in our software and hosting products." },
        { heading: "Your rights", body: "Access, rectification, erasure, restriction, portability and objection. Email privacy@coderlity.com and we respond within 30 days." },
        { heading: "Lawful basis", body: "We process personal data under contract (to deliver services), legitimate interests (product improvement, security) and consent (marketing)." },
        { heading: "Data processing agreement", body: "Enterprise customers can sign a DPA with SCCs for international transfers. Request one from legal@coderlity.com." },
        { heading: "Sub-processors", body: "We use AWS, Cloudflare, Stripe, SendGrid and Supabase. Full list available on request." },
        { heading: "Breach notification", body: "We notify affected customers and supervisory authorities within 72 hours of confirming a breach involving personal data." },
      ]}
    />
  );
}
